export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"description","content":"FINQ replaces the outdated financial middlemen by using big data and science to analyze the entire market continuously and offer objective investment solutions for everyone."}],"link":[{"rel":"icon","href":"/favicon.svg","type":"image/*"},{"rel":"preload","as":"font","href":"/assets/fonts/RAG-Sans-1.1-Light.woff2","type":"font/woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","href":"/assets/fonts/RAG-Sans-1.1-Regular.woff2","type":"font/woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","href":"/assets/fonts/RAG-Sans-1.1-Medium.woff2","type":"font/woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","href":"/assets/fonts/RAG-Sans-1.1-SemiBold.woff2","type":"font/woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","href":"/assets/fonts/RAG-Sans-1.1-ExtraBold.woff2","type":"font/woff2","crossorigin":"anonymous"}],"style":[{"innerHTML":"@font-face { font-family: \"RAG-Sans\"; src: url(\"/assets/fonts/RAG-Sans-1.1-Light.woff2\") format(\"woff2\"),url(\"/assets/fonts/RAG-Sans-1.1-Light.woff\") format(\"woff\"); font-weight: 300; font-display: swap; ascent-override: 80%; } @font-face { font-family: \"RAG-Sans\"; src: url(\"/assets/fonts/RAG-Sans-1.1-Regular.woff2\") format(\"woff2\"),url(\"/assets/fonts/RAG-Sans-1.1-Regular.woff\") format(\"woff\"); font-weight: 400; font-display: swap; ascent-override: 80%; } @font-face { font-family: \"RAG-Sans\"; src: url(\"/assets/fonts/RAG-Sans-1.1-Medium.woff2\") format(\"woff2\"),url(\"/assets/fonts/RAG-Sans-1.1-Medium.woff\") format(\"woff\"); font-weight: 500; font-display: swap; ascent-override: 80%; } @font-face { font-family: \"RAG-Sans\"; src: url(\"/assets/fonts/RAG-Sans-1.1-SemiBold.woff2\") format(\"woff2\"),url(\"/assets/fonts/RAG-Sans-1.1-SemiBold.woff\") format(\"woff\"); font-weight: 600; font-display: swap; ascent-override: 80%; } @font-face { font-family: \"RAG-Sans\"; src: url(\"/assets/fonts/RAG-Sans-1.1-ExtraBold.woff2\") format(\"woff2\"),url(\"/assets/fonts/RAG-Sans-1.1-ExtraBold.woff\") format(\"woff\"); font-weight: 800; font-display: swap; ascent-override: 80%; }"}],"script":[{"textContent":"window.dataLayer = window.dataLayer || [];"}],"noscript":[],"title":"Trust science to make you money","titleTemplate":"%s | FINQ","htmlAttrs":{"dir":"rtl","lang":"he"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = true

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true